module.exports = __webpack_public_path__ + "img/img-otp-01.png";